<template>
  <div class="container">
    <!-- survey.js 컴포넌트 삽입-->
    <survey :survey="survey"></survey>
    <div id='surveyResult'></div>
  </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.29.1/moment.min.js"></script>

<script>
// surveyJS를 import한다
import * as SurveyVue from "survey-vue";
import "bootstrap/dist/css/bootstrap.css";
import numeral from "numeral";
import moment from 'moment';

// surveyJS에서 Survey 컴포넌트만 따로 빼낸다
var Survey = SurveyVue.Survey;

// surveyJS 스타일 설정
Survey.cssType = "bootstrap";
//Survey.cssType = "modern";

export default {
  components: {
    // SurveyJS 컴포넌트 사용
    Survey
  },
  data() {
    // data() {}, computed : {} 둘다 가능
    var json = {
        //title: "양도세 계산기",
        //showProgressBar: "bottom",
        //progressBarType: "buttons",
        //goNextPageAutomatic: true,
        showNavigationButtons: true,
        showCompletedPage: false,
        requiredText: "(필수)",
        pages: [
            {
                navigationTitle: "거래대상",
                navigationDescription: "Your feedback",
                questions: [
                    {
                        type: "radiogroup",
                        name: "거래대상",
                        title: "거래하신 자산을 선택해주세요.",
                        //colCount: 1,
                        choices: ["주택", "분양권", "토지", "기타"],
                        isRequired: true,
                    },
                    {
                        type: "radiogroup",
                        name: "주택수",
                        title: "보유하신 주택 수를 선택해주세요.",
                        visibleIf: "{거래대상}='주택'",
                        isRequired: true,
                        choices: ["1주택", "2주택", "3주택 이상", "기타"],
                        defaultValue: "1주택",
                    },
                    {
                        type: "checkbox",
                        name: "조정지역_취득",
                        title: "조정대상지역",
                        visibleIf: "{거래대상}='주택' and {주택수}='1주택'",
                        choices: ["취득당시 조정대상지역"],
                        //isRequired: true,
                    },
                    {
                        type: "checkbox",
                        name: "조정지역_양도",
                        title: "조정대상지역",
                        visibleIf: "{거래대상}='주택' and ({주택수}='2주택' or {주택수}='3주택 이상')",
                        choices: ["양도당시 조정대상지역"],
                        //isRequired: true,
                    },
                    {
                        type: "checkbox",
                        name: "주택기타사항",
                        title: "기타사항",
                        colCount: 2,
                        visibleIf: "{거래대상}='주택'",
                        choices: ["다주택 전환", "임대주택"],
                    }, 
                    {
                        type: "radiogroup",
                        name: "토지사용목적",
                        title: "토지의 사용목적",
                        colCount: 2,
                        choices: ["사업용", "비사업용"],
                        visibleIf: "{거래대상}='토지'",
                        isRequired: true,
                    },
                    {
                        type: "checkbox",
                        name: "기타사항",
                        title: "기타사항",
                        colCount: 2,
                        defaultValue: ["기본공제"],
                        visibleIf: "{거래대상} notempty",
                        choices: ["기본공제", "공동명의"],
                    },
                    {
                        type: "text",
                        inputType: "number",
                        name: "지분율",
                        title: "양도할 지분율(%)",
                        visibleIf: "{기타사항} contains '공동명의'",
                        isRequired: true,
                        //description: "2020년 부부합산 소득금액(만원)을 입력하시기 바랍니다.",
                    },

                ]
            }, {
                navigationTitle: "양도차익",
                questions: [
                    {
                        type: "text",
                        inputType: "currency",
                        name: "양도가액",
                        title: "양도가액(원)",
                        isRequired: true,
                    }, {
                        type: "text",
                        inputType: "currency",
                        name: "취득가액",
                        title: "취득가액(원)",
                        isRequired: true,
                    }, {
                        type: "text",
                        inputType: "currency",
                        name: "필요경비",
                        title: "필요경비(원)",
                        isRequired: true,
                    }, 

                ]
            }, 
            {
                
                navigationTitle: "보유기간",
                questions: [
                    {
                        type: "text",
                        inputType: "date",
                        name: "취득일자",
                        title: "취득일자",
                        dateFormat: "yyyy-mm-dd",
                        isRequired: true,
                    }, {
                        type: "text",
                        inputType: "date",
                        name: "양도일자",
                        title: "양도일자",
                        dateFormat: "yyyy-mm-dd",
                        isRequired: true,
                    }, {
                        type: "radiogroup",
                        name: "거주기간",
                        title: "거주기간",
                        colCount: 2,
                        choices: ["보유기간 동일", "거주기간 없음"],
                        visibleIf: "{거래대상}='주택'",
                        isRequired: true,
                    },
                ]

            }
            
        ],
        
    };

    // 모델 로드
    var surveyModel = new SurveyVue.Model(json);

    // 로케일 설정
    surveyModel.locale = 'ko';    

    /*  css 세팅 
    var myCss = {
        //navigationButton: "ui button fluid",
        container : "container",
        question: {
        mainRoot: "ui segment",
        header: "ui header",
        title: "ui header",
            content : "ui input fluid",
            requiredText : ""
      },
        navigation: {
            complete: "ui button fluid blue",
            prev: "ui button fluid grey",
            next: "ui button fluid black",
            start: "btn sv_start_btn",
            preview: "btn sv_preview_btn",
            edit: "btn sv_edit_btn"
        },
        
    };
    surveyModel.css = myCss;
    */
    
    // 모델이 렌더링 된다음 입력항목에 대한 이벤트 추가
    surveyModel.onAfterRenderQuestionInput.add(function (survey, options) {

        // 타이핑 이벤트 추가
        $("input.form-control").on("input", function () {
            if ($(this).attr('type') == "currency") {
                $(this).val(numeral($(this).val()).format("0,0"));
            }
            
        });
        //console.log(options);
    });

    // 설문이 완료된 경우 이벤트
    surveyModel
      .onComplete
      .add(function (result) {

        var test_result = false;
        console.log(result.data);
        var 양도가액 = numeral(result.data['양도가액']).value();
        var 취득가액 = numeral(result.data['취득가액']).value();
        var 필요경비 = numeral(result.data['필요경비']).value();
        var 지분율 = numeral(result.data['지분율']).value();

        var 양도차익 = 양도가액 - 취득가액 - 필요경비;
        var 공제율 = 0;

        var 양도일자 = moment(result.data['양도일자']);
        var 취득일자 = moment(result.data['취득일자']);
        var 보유기간 = 양도일자.diff(취득일자, "years");
        //console.log(보유기간);
        var 장기보유특별공제 = 0;
        var 과세대상양도차익 = 0;

        // 장기보유 특별공제 기본세율
        if (보유기간 == 2) {
            공제율 = 0.0
        } else if (보유기간 == 3) {
            공제율 = 0.06
        } else if (보유기간 == 4) {
            공제율 = 0.08
        } else if (보유기간 == 5) {
            공제율 = 0.1
        } else if (보유기간 == 6) {
            공제율 = 0.12 
        } else if (보유기간 == 7) {
            공제율 = 0.14 
        } else if (보유기간 == 8) {
            공제율 = 0.16
        } else if (보유기간 == 9) {
            공제율 = 0.18
        } else if (보유기간 == 10) {
            공제율 = 0.20
        } else if (보유기간 == 11) {
            공제율 = 0.22
        } else if (보유기간 == 12) {
            공제율 = 0.24
        } else if (보유기간 == 14) {
            공제율 = 0.26
        } else if (보유기간 == 16) {
            공제율 = 0.28
        } else if (보유기간 >= 17) {
            공제율 = 0.3
        }

        
        // 과세대상양도차익 계산
        if (result.data['거래대상'] == "주택") {
        
            // 1세대 1주택 고가주택
            if (result.data['주택수'] == "1주택") {
            
                // 9억 이하 1주택인 경우 비과세
                if (양도가액 <= 900000000) {
                  과세대상양도차익 = 0;
                }
                else {  // 1주택이더라도 9억 이상인 경우 과세
                    
                    // 9억초과분 양도차익 안분계산
                    과세대상양도차익 = 양도차익 * (양도가액 - 900000000) / 양도가액;

                    // 1세대 1주택인 경우 장기보유 특별공제 세율
                    if (보유기간 == 2) {
                        공제율 = 0.08
                    } else if (보유기간 == 3) {
                        공제율 = 0.12
                    } else if (보유기간 == 4) {
                        공제율 = 0.16
                    } else if (보유기간 == 5) {
                        공제율 = 0.2
                    } else if (보유기간 == 6) {
                        공제율 = 0.24 
                    } else if (보유기간 == 7) {
                        공제율 = 0.28 
                    } else if (보유기간 == 8) {
                        공제율 = 0.32
                    } else if (보유기간 == 9) {
                        공제율 = 0.36
                    } else if (보유기간 >= 10) {
                        공제율 = 0.4
                    }

                    var 거주기간 = 보유기간;

                    // 거주기간 합산
                    if (거주기간 == 2) {
                        공제율 += 0.08
                    } else if (거주기간 == 3) {
                        공제율 += 0.12
                    } else if (거주기간 == 4) {
                        공제율 += 0.16
                    } else if (거주기간 == 5) {
                        공제율 += 0.2
                    } else if (거주기간 == 6) {
                        공제율 += 0.24 
                    } else if (거주기간 == 7) {
                        공제율 += 0.28 
                    } else if (거주기간 == 8) {
                        공제율 += 0.32
                    } else if (거주기간 == 9) {
                        공제율 += 0.36
                    } else if (거주기간 >= 10) {
                        공제율 += 0.4
                    }

                }
            }
            else { 
              과세대상양도차익 = 양도차익;    
            }
        }
        else {  // 주택이 아닌 경우
          과세대상양도차익 = 양도차익;
        }
        console.log(과세대상양도차익);

        장기보유특별공제 = 과세대상양도차익 * 공제율;
        console.log(장기보유특별공제);


        var 양도소득금액 = Math.max(0, 과세대상양도차익 - 장기보유특별공제);
        var 과세표준 = 양도소득금액;
        var 기본공제 = 0;
        
        if ("기타사항" in result.data) {
            // 기본공제 차감
            
            if (result.data["기타사항"].includes("공동명의")) {
                과세표준 = 과세표준 * 지분율 / 100;
            }

            if (result.data["기타사항"].includes("기본공제")) {
                기본공제 = Math.min(과세표준,2500000);
                과세표준 = 과세표준 - 기본공제;
            }
        }


        // 산출세액 계산

        var 산출세액 = 0;

        if (result.data['거래대상'] == '토지' & result.data['토지사용목적'] == "비사업용") {

            if (과세표준 <= 12000000) {
                산출세액 = 과세표준 * 0.06;
            } else if (과세표준 <= 46000000) {
                산출세액 = 과세표준 * 0.15 - 1080000;
            } else if (과세표준 <= 88000000) {
                산출세액 = 과세표준 * 0.24 - 5220000;
            } else if (과세표준 <= 150000000) {
                산출세액 = 과세표준 * 0.35 - 14900000;
            } else if (과세표준 <= 300000000) {
                산출세액 = 과세표준 * 0.38 - 19400000;
            } else if (과세표준 <= 500000000) {
                산출세액 = 과세표준 * 0.4 - 25400000;
            } else if (과세표준 > 500000000) {
                산출세액 = 과세표준 * 0.42 - 35400000;
            }

        } else {

            if (과세표준 <= 12000000) {
                산출세액 = 과세표준 * 0.06;
            } else if (과세표준 <= 46000000) {
                산출세액 = 과세표준 * 0.15 - 1080000;
            } else if (과세표준 <= 88000000) {
                산출세액 = 과세표준 * 0.24 - 5220000;
            } else if (과세표준 <= 150000000) {
                산출세액 = 과세표준 * 0.35 - 14900000;
            } else if (과세표준 <= 300000000) {
                산출세액 = 과세표준 * 0.38 - 19400000;
            } else if (과세표준 <= 500000000) {
                산출세액 = 과세표준 * 0.4 - 25400000;
            } else if (과세표준 > 500000000) {
                산출세액 = 과세표준 * 0.42 - 35400000;
            }
        }
        

        var 지방소득세 = 산출세액 * 0.1;
        var 결정세액 = 산출세액 + 지방소득세;

        console.log("양도차익", 양도차익);
        console.log("장기보유특별공제", 장기보유특별공제);
        console.log("과세대상양도차익", 과세대상양도차익);
        console.log("양도소득금액", 양도소득금액);
        console.log("과세표준", 과세표준);
        console.log("산출세액", 산출세액);
        console.log("결정세액", 결정세액);

        var result_html = "<table class='ui celled unstackable table'><thead><tr><th class='center aligned'>내용</th><th class='center aligned'>산식</th><th class='center aligned'>금액</th></tr></thead>";
        result_html += "<tbody>";
        result_html += "<tr><td>양도가액</td><td></td><td class='right aligned'>"+numeral(양도가액).format("0,0")+"원</td></tr>";
        result_html += "<tr><td>취득가액</td><td></td><td class='right aligned'>"+numeral(취득가액).format("0,0")+"원</td></tr>";
        result_html += "<tr><td>필요경비</td><td></td><td class='right aligned'>"+numeral(필요경비).format("0,0")+"원</td></tr>";
        result_html += "<tr class='active'><td>양도차익</td><td>양도가액-취득가액-취득가액</td><td class='right aligned'>"+numeral(양도차익).format("0,0")+"원</td></tr>";
        result_html += "<tr class='active'><td>과세대상 양도차익</td><td>비과세 차감 후 양도차익</td><td class='right aligned'>"+numeral(과세대상양도차익).format("0,0")+"원</td></tr>";
        result_html += "<tr><td>장기보유특별공제</td><td></td><td class='right aligned'>"+numeral(장기보유특별공제).format("0,0")+"원</td></tr>";
        result_html += "<tr class='active'><td>양도소득금액</td><td></td><td class='right aligned'>"+numeral(양도소득금액).format("0,0")+"원</td></tr>";
        if (result.data["기타사항"].includes("공동명의")) {
            result_html += "<tr><td>지분율</td><td></td><td class='right aligned'>"+numeral(지분율).format("0,0")+"%</td></tr>"
            result_html += "<tr class='active'><td>과세대상 소득금액</td><td></td><td class='right aligned'>"+numeral(양도소득금액*result.data['지분율']).format("0,0")+"원</td></tr>"
        };
        result_html += "<tr><td>기본공제</td><td></td><td class='right aligned'>"+numeral(기본공제).format("0,0")+"원</td></tr>";
        result_html += "<tr  class='active'><td>과세표준</td><td>양도소득금액-기본공제</td><td class='right aligned'>"+numeral(과세표준).format("0,0")+"원</td></tr>";
        result_html += "<tr><td>양도소득세</td><td></td><td class='right aligned'>"+numeral(산출세액).format("0,0")+"원</td></tr>";
        result_html += "<tr><td>지방소득세</td><td>양도소득세*10%</td><td class='right aligned'>"+numeral(지방소득세).format("0,0")+"원</td></tr>";
        result_html += "<tr class='active'><td>총납부액</td><td>양도소득세+지방소득세</td><td class='right aligned'>"+numeral(결정세액).format("0,0")+"원</td></tr>";
        result_html += "</tbody>";
        result_html += "</table>";
        //result_html += "<button class='ui button fluid red' onclick='reset_survey();'>다시 계산하기</button>"

        document
            .querySelector('#surveyResult')
            .innerHTML = result_html;

    });
    return {
      //survey 컴포넌트를 반환
      survey: surveyModel
    };
  }
};
</script>

<style>

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

/*
@import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
body, div, span, h1, h2, h3, h4, h5, table, input { font-family: 'Noto Sans KR', sans-serif !important; }
*/

body {
    font-size:15px;
    
}

div.container {
    padding: 0px
}

.sv-title-actions__title {
    font-size:15px;
}

div.panel-body {
    padding : 0;
}

.sv_bootstrap_css .sv_qstn {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

div.small {
    padding-bottom: 5px;
}


@media only screen and (min-width: 1200px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: -1px !important;
    }
}

@media only screen and (max-width: 770px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 4px !important;
    }
}

@media only screen and (max-width: 600px) {
    .sv_bootstrap_css .sv_qcbc input[type="checkbox"], .sv_bootstrap_css .sv_qcbc input[type="radio"] {
        margin-top: 0px !important;
    }
}

</style>
